import classNames from 'classnames';
import React from 'react';

type Props = {
  children?: React.ReactNode,
  nowrap?: boolean
};

class Toolbar extends React.Component<Props> {
  override render (): React.ReactNode {
    const { nowrap, children } = this.props;

    return (
      <div className='esko_toolbar'>
        <div className='esko_container'>
          <div className={classNames('esko_toolbarcontent', {esko_nowrap: nowrap})} role='toolbar'>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default Toolbar;
